import angular from 'angular';
import progressBarComponent from './progress-bar.component';

let progressBarModule = angular.module('tcProgressBar', [])
  .component('tcProgressBar', progressBarComponent);

export default progressBarModule;




// WEBPACK FOOTER //
// ./client/common/directives/progress-bar/progress-bar.js